// Angular and RJX Imports
// =========================================================
import { Component, type OnInit } from '@angular/core'
// Prime NG Imports
// =========================================================
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog'
import { type TreeNode } from 'primeng/api'
// Custom Imports
// =========================================================
import { type TreeDataParamsInterface } from 'src/app/core/interfaces/data-expected-from-backend/default-parameters-inputs-interface'
import { StoreIndexAPIs } from 'src/app/core/apis/store-index_api-calls'

@Component({
  standalone: false,
  selector: 'app-index-copy-new-product-modal',
  templateUrl: './index-copy-new-product-modal.component.html',
  styleUrls: ['./index-copy-new-product-modal.component.scss']
})
export class IndexCopyNewProductModalComponent implements OnInit {
  // Params for Product Hierarchy Section
  treeDataParams: TreeDataParamsInterface | null = null
  submittingData: boolean = false
  loadingMessage: string = 'submitting'
  selectedHierarchyNode: TreeNode = {}
  defaultSelected: TreeNode[] = []

  selectedSource: string | null = null
  selectedSTYC_name: string | null = null
  selectedDestination: any = null
  parentGridData: any
  selectedIndexIds: number[] = []

  constructor (
    public readonly ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private readonly storeIndexAPIs: StoreIndexAPIs
  ) {
    console.log('---> Inside Store Index Copy - New Product: ', this.config.data)
    this.parentGridData = {
      ...this.config?.data?.componentParent,
      rowData: config?.data.rowData
    }
  }

  ngOnInit () {
    // Set hierarchy tree data params
    this.treeDataParams = {
      queryString: '?',
      selectedProd: null
    }
    const { index_id, product_nm, product_node } = this.parentGridData.rowData[0]
    this.selectedSource = product_node
    this.selectedSTYC_name = product_nm
    this.selectedIndexIds = this.parentGridData.rowData.map(row => row.index_id).filter(id => id != null)
  }

  // Load the hierarchy tree data
  // async getAllProducts () {
  //   try {
  //     console.log('---> Getting all Products')
  //     // this.treeDataParams = {
  //     //   queryString: '?for_index_copy=true',
  //     //   selectedProd: null
  //     // };
  //   } finally {
  //     console.log('--> async function completed')
  //   }
  // }

  //  Hierarchy Node Selected
  async onNodeSelected (event) {
    console.log('Product Creation Node Selected: ', event)
    this.selectedHierarchyNode = event.node
    this.selectedDestination = {
      label: event.node.label,
      key: event.node.key
    }
  }

  async onSubmit (event) {
    console.log('---> Submitting New Product')
    console.log('---> Selected Source: ', this.selectedSource)
    console.log('---> Selected Destination: ', this.selectedDestination)
    this.submittingData = true

    const data = {
      index_ids: this.selectedIndexIds,
      target: this.selectedDestination
    }

    await this.storeIndexAPIs.OnIndexCopyProduct(data).then(res => {
      if (res?.is_success) {
        this.close({
          message: 'success',
          data
        })
      } else {
        this.submittingData = false
        this.close()
      }
    })
  }

  close (data?: any) {
    if (this.ref) this.ref.close(data || null)
  }
}
